import { render, staticRenderFns } from "./TranslationInput.vue?vue&type=template&id=01b81616&scoped=true&"
import script from "./TranslationInput.vue?vue&type=script&lang=js&"
export * from "./TranslationInput.vue?vue&type=script&lang=js&"
import style0 from "./TranslationInput.vue?vue&type=style&index=0&id=01b81616&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b81616",
  null
  
)

export default component.exports